import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { OptionGroupType } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel, EventOption } from '@frontend/sports/betting-offer/feature/model';
import { map } from 'rxjs';

import { ISheetViewState, sheetViewStateSelector } from '../../sheet-view-core/sheet-view.state';
import { BaseOptionGroupStatisticsService } from './base-option-group-statistics.service';

export interface StatisticsParams {
    optionGroupId?: string;
    playerName: string;
    key?: string;
    optionId?: string;
}

export interface IPlayerPropsOptionLine {
    playerId: number | undefined;
    playerName: string;
    overOption?: EventOption;
    underOption?: EventOption;
    showStats?: boolean;
}

@Injectable()
export class OptionGroupPlayerStatisticsService extends BaseOptionGroupStatisticsService {
    readonly isSheetViewOpen = toSignal(
        this.store.select(sheetViewStateSelector).pipe(map((sheetViewState: ISheetViewState) => sheetViewState.isOpen)),
        { initialValue: false },
    );

    toggleOpen(event: EventModel, params: StatisticsParams, optionGroup?: any, marketType?: OptionGroupType): void {
        const { optionGroupId, playerName, optionId } = params;
        const isStatisticsOpen = this.isOpen(params);

        this.playerStatisticsService.openStatistics({
            eventId: event.id,
            marketFilter: optionGroup.originalId,
            playerName,
            marketId: optionGroupId,
            optionId,
            isOpen: !isStatisticsOpen,
            tracking: isStatisticsOpen,
            loadedTracking: isStatisticsOpen,
            marketType,
        });
    }

    isOpen(params: StatisticsParams): boolean {
        const { optionGroupId, optionId } = params;
        return !!this.playerStatisticsService.getPlayerStatistics(this.playerStatistics()?.data, optionGroupId, optionId, false)?.isOpen;
    }

    isPlayer(event: EventModel, playerName: string): boolean {
        return this.playerStatisticsService.isPlayer(event.players, playerName);
    }
}
